/**
 * Subscreen GoogleConnect
 */

import React, { useCallback, useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ButtonComponent from '@professocial/professocialFormComponents/FormComponents/ButtonComponent'

import { useDispatch, useSelector } from 'react-redux'
import {
  InitiateConnectOperationRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/SmPublishConnectApi'
import {
  getSmPublishAuthTokenInitiated,
  initiateGoogleConnectInitiated,
  setGoogleConnectHash,
  socialmediaUserConnectInitiated,
  socialmediaUserDisconnectInitiated,
} from '../../../store/common/common.actions'
import { NetworkType, SocialmediaConnectionState } from '@professocialApi/professocial-core-frontend-api/models'
import {
  getGoogleConnectHash,
  getTokenChanged,
} from '../../../store/common/common.selectors'
import { ISettingsConnectProps } from './SettingsConnect'
import {
  SocialmediaUserConnectRequest,
  SocialmediaUserDisconnectRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/SocialmediaUserApi'

const SettingsGoogleConnect: React.FC<ISettingsConnectProps> = (props) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  // true, wenn sich die connection geändert hat
  // const connectionChanged: boolean = useSelector(getConnectionChanged)
  // true, wenn der Token sich geändert hat
  const tokenChanged: boolean = useSelector(getTokenChanged)

  const [googleConnection, setGoogleConnection] = useState<boolean>(false)
  const [disableConnection, setDisableConnection] = useState<boolean>(false)

  const connectHash: string | undefined = useSelector(getGoogleConnectHash)
  // const connectedPage: string | undefined = useSelector(getConnectedInstagramPage)

  const dispatchSocialmediaUserConnect = useCallback((params: SocialmediaUserConnectRequest) => dispatch(socialmediaUserConnectInitiated(params)), [dispatch])
  const dispatchSocialmediaUserDisconnect = useCallback((params: SocialmediaUserDisconnectRequest) => dispatch(socialmediaUserDisconnectInitiated(params)), [dispatch])

  const dispatchSetGoogleConnectHash = useCallback((params: string | undefined) => dispatch(setGoogleConnectHash(params)), [dispatch])
  // const dispatchSetConnectedGooglePage = useCallback((params: string | undefined) => dispatch(setConnectedGooglePage(params)), [dispatch])
  const dispatchGetToken = useCallback(() => dispatch(getSmPublishAuthTokenInitiated()), [dispatch])

  const dispatchInitiateConnect = useCallback((params: InitiateConnectOperationRequest) => dispatch(initiateGoogleConnectInitiated(params)), [dispatch])
  // const dispatchPerformConnect = useCallback((params: PerformConnectOperationRequest) => dispatch(performConnectInitiated(params)), [dispatch])
  // const dispatchPerformDisconnect = useCallback((params: PerformDisconnectRequest) => dispatch(performDisconnectInitiated(params)), [dispatch])

  useEffect(() => {
    // hier zunächst den neuen JWT Abholen bevor es weiter geht
    dispatchGetToken()
  }, [connectHash],
  )

  useEffect(() => {
    // der State gibt an, ob man bereits mit verbunden ist oder eine Verbindung überhaupt möglich ist
    if (props.connection?.state === SocialmediaConnectionState.Connected) {
      setGoogleConnection(true)
      setDisableConnection(false)

      // wenn wir connected sind, können wir den Hash abholen, mit dem wir dann auch Sieten erhalten die wir anschließend verbinden und trennen können
      const params: InitiateConnectOperationRequest = {
        initiateConnectRequest: {
          networkType: NetworkType.GoogleMyBusiness,
        },
      }
      dispatchInitiateConnect(params)
    } else {
      if (props.connection?.state === SocialmediaConnectionState.Disabled || props.connection?.state === SocialmediaConnectionState.Invalid) {
        setDisableConnection(true)
      } else {
        setDisableConnection(false)
      }
      setGoogleConnection(false)
    }
  }, [props.connection],
  )

  useEffect(() => {
    // hier zunächst den neuen JWT Abholen bevor es weiter geht
    dispatchGetToken()
  }, [connectHash],
  )

  useEffect(() => {
    // wenn wir einen Hash haben, dann laden wir die verfügbaren Google Seiten
    dispatchSetGoogleConnectHash(connectHash || undefined)
  }, [tokenChanged],
  )

  // useEffect(() => {
  //   // wenn wir einen Hash haben, dann laden wir die verfügbaren Google Seiten
  //   getGoogleConnectDataElements()
  // }, [googleConnectHash],
  // )

  // useEffect(() => {
  //   connectionChanged && getGoogleConnectDataElements()
  // }, [connectionChanged],
  // )

  return (
    <>
      <Typography
        sx={{ mb: 3 }}>{googleConnection ? t('coreSettings:googleConnectionDesc') : t('coreSettings:noConnection')}</Typography>
      <ButtonComponent
        disabled={disableConnection}
        onClick={() => {
          if (googleConnection) {
            // Verbindung mit OAuth trennen
            if (props.connection?.id) {
              const params: SocialmediaUserDisconnectRequest = {
                connectionId: props.connection?.id,
              }
              dispatchSocialmediaUserDisconnect(params)
            }
          } else {
            // Verbindung mit OAuth herstellen
            if (props.connection?.id) {
              const params: SocialmediaUserConnectRequest = {
                connectionId: props.connection?.id,
                redirectUrl: window.location.href,
              }
              dispatchSocialmediaUserConnect(params)
            }
          }
        }}
        text={
          <Box sx={{ display: 'flex', alignItems: 'center', textTransform: 'initial' }}>
            <Typography sx={{ pr: 0.5 }}>{t('coreSettings:disconnectStart')}</Typography>
            <Typography><b>profes</b><i>social</i></Typography>
            <Box sx={{ display: 'flex', fontSize: '0.6rem', alignSelf: 'start', pl: 0.2 }}>©</Box>
            <Typography
              sx={{ pl: 0.5 }}>{googleConnection ? t('coreSettings:disconnectEnd') : t('coreSettings:connectEnd')}</Typography>
          </Box>
        }
      />
      {connectHash && googleConnection &&
        <>
          {/* {googlePages && googlePages.length !== 0 */}
          {/*  ? ( */}
          {/*    <> */}
          {/*      <Box> */}
          {/*        <Typography variant='h4' sx={{ mt: 4 }}>{t('coreSettings:fbConnectedPages')}</Typography> */}
          {/*        {connectedPage */}
          {/*          ? ( */}
          {/*            <> */}
          {/*              {googlePages && googlePages.map((googlePage: GoogleConnectDataElement, index: number) => { */}
          {/*                if (googlePage.isConnected) { */}
          {/*                  return ( */}
          {/*                    <ConnectPages */}
          {/*                      key={index} */}
          {/*                      disabled={false} */}
          {/*                      page={googlePage} networkType={NetworkType.GoogleMyBusiness} disconnect={(networkPageId: string) => { */}
          {/*                        const params: PerformDisconnectRequest = { */}
          {/*                          performConnectRequest: { */}
          {/*                            connectHash: connectHash, */}
          {/*                            networkPageId: networkPageId, */}
          {/*                          }, */}
          {/*                        } */}
          {/*                        dispatchPerformDisconnect(params) */}
          {/*                      }} */}
          {/*                    /> */}
          {/*                  ) */}
          {/*                } */}
          {/*              })} */}
          {/*            </>) : <NoDataComponent noDataText={t('coreSettings:noConnectedPages')} alignment='left' margin='16px 0' />} */}
          {/*      </Box> */}
          {/*      <Box> */}
          {/*        <Typography variant='h4' sx={{ mt: 4 }}>{t('coreSettings:fbAvailablePages')}</Typography> */}
          {/*        {googlePages && googlePages.map((googlePage: GoogleConnectDataElement, index: number) => { */}
          {/*          if (!googlePage.isConnected) { */}
          {/*            return ( */}
          {/*              <ConnectPages */}
          {/*                key={index} */}
          {/*                disabled={!!connectedPage} */}
          {/*                page={googlePage} networkType={NetworkType.GoogleMyBusiness} connect={(networkPageId: string) => { */}
          {/*                  const params: PerformConnectOperationRequest = { */}
          {/*                    performConnectRequest: { */}
          {/*                      connectHash: connectHash, */}
          {/*                      networkPageId: networkPageId, */}
          {/*                    }, */}
          {/*                  } */}
          {/*                  dispatchPerformConnect(params) */}
          {/*                  window.localStorage.setItem('googlePageNetworkId', networkPageId) */}
          {/*                }} */}
          {/*              /> */}
          {/*            ) */}
          {/*          } */}
          {/*        })} */}
          {/*      </Box> */}
          {/*    </>) */}
          {/*  : ( */}
          {/*    <> */}
          {/*      <Preloader /> */}
          {/*    </>)} */}
        </>}
    </>
  )
}
export default SettingsGoogleConnect
